export function usePricingGroup({
  groupSlug,
  immediate = true,
  server = true,
  includeDescriptions = false
}) {
  const pricingStore = usePricingStore();
  const forceRefresh = ref(false);
  const pricingGroupKey = `${groupSlug}-${includeDescriptions ? 'with-descriptions' : 'without-descriptions'}`;

  const asyncData = useAsyncData(
    `pricing-group-${pricingGroupKey}`,
    async () => {
      try {
        return await pricingStore.getGroupProducts({
          groupSlug,
          includeDescriptions,
          forceRefresh: forceRefresh.value
        });
      } finally {
        forceRefresh.value = false;
      }
    },
    {
      immediate,
      server
    }
  );

  async function retry() {
    forceRefresh.value = true;
    await asyncData.refresh();
  }

  return {
    products: asyncData.data,
    pending: asyncData.pending,
    error: asyncData.error,
    load: asyncData.refresh,
    retry
  };
}
